import "./Content.css";

const ContentAbout = () => {
  return (
    <div className="content-about">
      <div className="content-about-wrap">
        {/* LEFT */}
        <div className="about-left">
          <p className="about-hint">Hover on the picture to see small animation</p>
          <div className="content-about-image" />
        </div>

        {/* RIGHT */}
        <div className="about-right">
          <h1 className="about-title">About Me</h1>

          <p>
            My name is <b>Ivan Setiawan</b>. I’m currently studying{" "}
            <b>HBO ICT – Media & Design</b> at{" "}
            <b>Fontys University of Applied Sciences</b> in Eindhoven.
          </p>

          <p>
            I enjoy working on interactive digital experiences where design,
            technology, and user experience come together. I’m especially
            interested in projects that involve experimentation, creativity,
            and hands-on problem solving.
          </p>

          <p>
            Instead of only documenting my work through reports or assignments,
            I chose to build this portfolio website as a space to reflect my
            learning process and continuously improve my design and development
            skills.
          </p>

          <div className="about-contact">
            <h2>Contact</h2>
            <p>
              Eindhoven, Netherlands
              <br />
              +31 6 1389 2611
              <br />
              516415@student.fontys.nl
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentAbout;
